import React, { memo } from 'react';
import styled from 'styled-components';
import IconChevronRight from '@tvg/fuse-icons/lib/ChevronRight';
import {
  TypographyComponent as TypographyElement,
  MarketingCard as MarketingCardComponent,
  SpanLink,
  global,
} from '@tvg/fuse-design';
import CardButton from 'components/CardButton/CardButton';
import { CustomPromotionVoucher } from 'types/Product';
import analyticsEvent from '../../../services/analytic/analytic-service';

const StyledMarketingCard = styled(MarketingCardComponent)`
  box-shadow: var(--elevation-shadow-xs);
  border-radius: 6px;
  padding: var(--spacing-global-space5);
  display: flex;
  margin-bottom: var(--spacing-space24);
`;
const StyledTypography = styled(TypographyElement)`
  padding: 0 0 var(--spacing-space8) 0;
`;
const StyledCardButton = styled(CardButton)`
  > * {
    display: block;
  }
`;

const CardDescription = styled.div`
  padding-bottom: var(--spacing-space8);

  .card-description-style {
    p {
      color: var(--color-font-paragraph);
      font-weight: var(--font-weight-paragraph);
      font-size: calc(var(--font-size-m1) + 1px);
      line-height: calc(var(--font-line-height-m1) + 1px);
      padding-bottom: var(--spacing-space8);
    }

    h1 {
      color: var(--color-font-heading);
      font-weight: var(--font-weight-heading);
      font-size: var(--font-size-2);
      line-height: var(--font-line-height-2);
      padding-bottom: var(--spacing-space8);
    }

    span {
      color: var(--color-font-heading);
      font-weight: var(--font-weight-heading);
      font-size: calc(var(--font-size-m1) + 1px);
      line-height: calc(var(--font-line-height-m1) + 1px);
    }
  }
`;

const BorderDiv = styled.div`
  border-top: 1px solid ${global.grey400};
  padding: var(--spacing-space16) 0 0 0;
`;

interface CustomPromotionVoucherCardProps {
  promotionVoucher: CustomPromotionVoucher;
  openDialog: () => void;
}

const CustomVoucherCard = memo(({ promotionVoucher, openDialog }: CustomPromotionVoucherCardProps) => {
  const { cardTitle, cardDescription, cardHyperlinkText } = promotionVoucher;
  const onClickHandler = () => {
    openDialog();

    analyticsEvent({
      gaAction: 'Product Page - Custom Promotion voucher',
      gaLabel: `${cardTitle} moreinfo`,
    });
  };

  return (
    <StyledCardButton onClick={onClickHandler}>
      <StyledMarketingCard dataTestId="custom-promotion-voucher-card">
        <StyledTypography color="var(--color-brand-mid)" size={{ l: '2', xxs: '1' }}>
          {cardTitle}
        </StyledTypography>
        <CardDescription
          dangerouslySetInnerHTML={{
            __html: `${cardDescription}`,
          }}
        />
        <BorderDiv />
        <SpanLink icon={<IconChevronRight />} iconRight size="medium">
          {cardHyperlinkText}
        </SpanLink>
      </StyledMarketingCard>
    </StyledCardButton>
  );
});

export default CustomVoucherCard;
